<template>
  <h1>Sådan virker KL's valgberegner</h1>
  <p>Her kan du læse om de forskellige funktioner i KL’s valgberegner:</p>
  <p>
    <em> Titel </em><br />
    Du navngiver din beregning i feltet ”Titel”.
  </p>

  <p>
    <em> Mandater til fordeling </em><br />
    Under ”Mandater til fordeling” skal du angive et antal mandater mellem 1 og
    999, samt mindst to partier for at kunne lave en beregning.
  </p>

  <p>
    <em> Spærregrænse % </em><br />
    Her er der mulighed for at angive en spærregrænse, der er en procentdel af
    det samlede antal stemmer, som hvert parti skal have opnået, for at blive
    inkluderet i beregningen.
  </p>

  <p>
    <em> Parti/liste </em><br />
    Under ”Parti/liste” kan du enten indlæse ”Kommunale valgresultater” for 2021
    eller indtaste egne data.
  </p>
  <p>
    Du kan tilføje yderligere rækker med "+" knappen, og fjerne rækker ved at
    trykke på "x" knappen til højre. Med "Nulstil" knappen kan man hurtigt
    fjerne alle indtastede data, og starte forfra.
  </p>

  <p>
    <em>Indlæs kommunale valgresultater</em><br />
    Udover at lave dine egne beregninger er det også muligt at indlæse
    valgresultaterne fra din kommune. Det sker ved at bruge ”Indlæs kommunale
    valgresultater” funktionen og derefter vælge den ønskede kommune.
  </p>

  <p>
    <em>Valgforbund</em><br />
    For både dine egne indtastede data og for de indlæste, kommunale
    valgresultater er det muligt at oprette valgforbund. Det sker ved at benytte
    knappen ”Valgforbund”, og så derefter angive de partier/lister, der skal
    indgå i de forskellige valgforbund.
  </p>

  <p>
    <em>Beregn mandatfordeling</em><br />
    Ved tryk på knappen "Beregn mandatfordeling" skiftes der til en side, der
    opstiller den beregnede mandatfordeling i en tabel.
  </p>
  <p>
    Har du behov for yderligere detaljer om fordelingen, så kan du anvende
    funktionen "Vis detaljeret mandatfordeling". Herved vises en side med den
    komplette beregning, opstillet i en tabel, der også synliggør de sikre
    mandater, og eventuelle lodtrækninger.
  </p>
  <p>
    I den detaljerede mandatfordeling angives rækkefølgende på fordelingen af
    mandaterne med følgende grafik:
  </p>
  <p style="color: green;">Grøn (x) = valgt</p>
  <p style="color: orange;">Gul (x) = lodtrækning</p>
  <p style="color: red;">Rød (x) = ikke valgt</p>

  <p>
    <em>Eksporter</em><br />Det er muligt at få eksporteret sine beregninger til
    Excel og få den sendt til din mail ved hjælp af knappen ”Eksporter” Der er
    altid mulighed for at gå tilbage og ændre i indtastede data, så nye
    beregninger hurtigt kan foretages.
  </p>
</template>

<script>
export default {
  components: {},
};
</script>
